/*
  CUSTOM: shop the look on the product page's images. Markup: snippets/media.liquid with snippets/shop-the-look.liquid:
  the pin, its name and the tray on the look's image (data-stl-slide), the bag button on every image. Styles:
  assets/shop-the-look.css.
  - The bag button sits by the zoom button on every image and shows how many products the look has. On the look's
    image it opens the tray over the bottom of the picture (the product fact on the picture is hidden meanwhile) and
    is a small X while the tray is open; from another image it first goes to the look's image.
  - A tap on the pin opens the tray with the product's name above the pin. A tap on the image, or another image,
    closes the tray.
  - Until the customer has opened the look once (localStorage "stl-tried"), the bag unfolds to "Ny · Shop the look"
    and folds back, once the picture is shown and the images are in view.
  "+" and the name open quick add (assets/theme-custom.js, as on the cards).
*/
(function () {
  'use strict';

  var $slide = document.querySelector('[data-stl-slide]');
  var $photos = $slide && $slide.closest('[data-product-photos]');
  var $main = $photos && $photos.closest('.product__main-photos');
  if (!$main) return;

  var $dot = $slide.querySelector('[data-stl-dot]');
  var $label = $slide.querySelector('[data-stl-label]');
  var triedKey = 'stl-tried';
  var isOpen = false;

  function slideshow() {
    return window.Flickity && window.Flickity.data($photos);
  }

  function selectedSlide() {
    return $photos.querySelector('.product-main-slide.is-selected') || $photos.querySelector('.product-main-slide');
  }

  function onLookSlide() {
    return selectedSlide() === $slide;
  }

  // the name stays inside the picture: moved in from an edge, and under the pin when there is no room above it
  function placeLabel() {
    if (!$label || !$label.classList.contains('is-active')) return;
    var wrap = $label.parentNode.getBoundingClientRect();
    $label.style.marginLeft = '0px';
    $label.classList.remove('is-below');
    var at = $label.getBoundingClientRect();
    if (at.top < wrap.top + 8) {
      $label.classList.add('is-below');
      at = $label.getBoundingClientRect();
    }
    var shift = 0;
    if (at.left < wrap.left + 8) shift = wrap.left + 8 - at.left;
    else if (at.right > wrap.right - 8) shift = wrap.right - 8 - at.right;
    $label.style.marginLeft = shift + 'px';
  }

  function setPin(on) {
    [$dot, $label].forEach(function ($el) {
      if ($el) $el.classList.toggle('is-active', on);
    });
    if ($dot) $dot.setAttribute('aria-expanded', on ? 'true' : 'false');
    placeLabel();
  }

  function setTabs(open) {
    $photos.querySelectorAll('[data-stl-tab]').forEach(function ($tab) {
      $tab.classList.remove('is-intro');
      $tab.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function open(fromPin) {
    isOpen = true;
    $main.classList.add('stl-open');
    setTabs(true);
    setPin(!!fromPin);
    try {
      localStorage.setItem(triedKey, '1');
    } catch (e) {}
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    $main.classList.remove('stl-open');
    setTabs(false);
    setPin(false);
  }

  // a bag: on the look's image it opens and closes the tray; from another image it goes there first
  function tabClick() {
    if (isOpen) {
      close();
      return;
    }
    if (onLookSlide()) {
      open(false);
      return;
    }
    var flickity = slideshow();
    var index = -1;
    if (flickity) {
      flickity.cells.forEach(function (cell, i) {
        if (cell.element === $slide) index = i;
      });
    }
    if (index < 0) return;
    flickity.select(index);
    setTimeout(function () {
      if (onLookSlide()) open(false);
    }, 450);
  }

  // the bags and the pin, on the document: a click the slideshow stopped (the end of a swipe) is no tap
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || !e.target.closest) return;
    if (e.target.closest('[data-stl-tab]')) {
      tabClick();
    } else if (e.target.closest('[data-stl-dot]')) {
      if (isOpen && $dot.classList.contains('is-active')) close();
      else if (onLookSlide()) open(true);
    }
  });

  // before the theme's clicks: the end of a swipe that started on the look's parts opens nothing (no quick add), and
  // with the tray open a tap on the image closes it and does nothing else (no zoom)
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-product-photos]')) return;
    var $part = e.target.closest('[data-stl-tray], [data-stl-label], [data-stl-tab], [data-stl-dot]');
    var flickity = slideshow();
    if ($part && flickity && flickity.isPreventingClicks) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!isOpen || $part) return;
    e.preventDefault();
    e.stopPropagation();
    close();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen && !document.documentElement.classList.contains('quick-add-open')) close();
  });

  // another image closes the tray (the slideshow marks the image in view .is-selected)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      if (!onLookSlide()) close();
    });
    $photos.querySelectorAll('.product-main-slide').forEach(function ($el) {
      observer.observe($el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  window.addEventListener('resize', function () {
    if (isOpen) placeLabel();
  });

  // new to it: the bag unfolds to "Ny · Shop the look" and back, until the look has been opened once. Not before the
  // picture is shown and the images are in view, so the customer sees it
  function intro() {
    var $tab = selectedSlide().querySelector('[data-stl-tab]');
    if (isOpen || !$tab) return;
    $tab.classList.add('is-intro');
    setTimeout(function () {
      $tab.classList.remove('is-intro');
    }, 3600);
  }

  function introInView() {
    if (!window.IntersectionObserver) {
      setTimeout(intro, 900);
      return;
    }
    var seen = new IntersectionObserver(function (entries) {
      if (entries[0].intersectionRatio < .5) return;
      seen.disconnect();
      setTimeout(intro, 900);
    }, { threshold: .5 });
    seen.observe($photos);
  }

  var tried = false;
  try {
    tried = !!localStorage.getItem(triedKey);
  } catch (e) {}
  if (!tried) {
    var $picture = selectedSlide().querySelector('img');
    if (!$picture || $picture.complete) {
      introInView();
    } else {
      $picture.addEventListener('load', introInView, { once: true });
      $picture.addEventListener('error', introInView, { once: true });
    }
  }
})();
